import { calculatePaginationOffset, convertSortToQueryString, } from "@sscs/utils";
import { REPORTS_ENDPOINT } from "../../constants";
import { baseApi } from "./base.api.required.stub";
const saasbomApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getServices: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/saasbom`,
                params: {
                    auth: data.filter.auth,
                    flow: data.filter.flow,
                    name: data.filter.name,
                    provider: data.filter.provider,
                    type: data.filter.type,
                    sort_by: convertSortToQueryString(data.sort),
                    limit: data.pagination.itemsPerPage,
                    offset: calculatePaginationOffset(data.pagination),
                },
            }),
        }),
        getServiceDetails: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/saasbom/${data.ui_item_id}/details`,
                params: {
                    limit: data.pagination.itemsPerPage,
                    offset: calculatePaginationOffset(data.pagination),
                },
            }),
        }),
        getServiceProviders: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/saasbom/providers`,
            }),
        }),
        getServiceTypes: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/saasbom/service-types`,
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useGetServicesQuery, useGetServiceDetailsQuery, useLazyGetServiceProvidersQuery, useLazyGetServiceTypesQuery, } = saasbomApi;
//# sourceMappingURL=saasbom.api.js.map